import { SvgIcon } from '@progress/kendo-react-common';
import React from 'react';
import { useWorkspaceItemContext } from '../../../app/contexts/workspace/workspace-item-context';
import { DateTimeFormatter } from '../../../formatters';
import { ChevronRightOutline } from '../../../icons/icons';
import { FlightPreDepContextMenuData } from '../../../services/map-interaction-service';
import { Menu } from '../../common/menu/DropdownMenu';
import { FlightContextMenuContent } from './FlightContextMenuContent';

export function PreDepartureContextMenu(props: { info: FlightPreDepContextMenuData }) {
    const context = props.info;
    const workspaceContext = useWorkspaceItemContext();

    const clickHandler = React.useCallback(
        (id: number) => {
            workspaceContext.flightLayerFacade.selection.selectFlight(id, { source: 'manual' });
            workspaceContext.interactionService.dismissContextMenu();
        },
        [context, workspaceContext]
    );

    return (
        <>
            <div style={{ fontSize: 12, width: 220 }}>
                <PreDepartureItem onClick={clickHandler} name="Planned" item={context.flights.planned} />
                <PreDepartureItem onClick={clickHandler} name="Scheduled" item={context.flights.scheduled} />
            </div>
        </>
    );
}

function PreDepartureItem(props: {
    item: FlightPreDepContextMenuData['flights']['planned'];
    name: string;
    onClick?: (id: number) => void;
}) {
    if (!props.item.some((x) => x.items.length > 0)) {
        return <></>;
    }

    return (
        <div>
            <div className="text-center bg-color p-1" style={{ fontSize: '1.15em' }}>
                {props.item.map((x) => x.airport).join('/')} {props.name}
            </div>
            {props.item.map((x) =>
                x.items.map((x) => (
                    <Menu
                        key={x.id}
                        customContent={
                            <div className="flex-grow-1 d-flex gap-2 px-2 py-1">
                                <div style={{ width: '35%' }} className="text-start">
                                    {x.acid}
                                </div>
                                <div style={{ width: '40%' }} className="text-start">
                                    {DateTimeFormatter.formatTime(x.depTime)}
                                </div>
                                <div style={{ width: '25%' }} className="text-start">
                                    {x.acType}
                                </div>
                                <SvgIcon icon={ChevronRightOutline} size="small" className="flex-shrink-0" />
                            </div>
                        }>
                        <FlightContextMenuContent id={x.id} />
                    </Menu>
                ))
            )}
        </div>
    );
}
